<script>
import appConfig from "@/app.config";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import AnketYanitlarSingleOran from "./AnketYanitlarSingleOran.vue";
import Drawer from "vue-simple-drawer";

export default {
  mixins: [Api, Sabit],
  props: ["Data"],
  page: {
    title: "Anket Oluştur",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { AnketYanitlarSingleOran, Drawer },
  data() {
    return {
      title: this.$t("CreateAnket.Title"),
      items: [
        {
          text: this.$t("CreateAnket.Title"),
          active: true,
        },
      ],
      AnktAnketId: this.$route.params.AnktAnketId,
      FormData: [],
      FormJson: [],
      FilitrelemePenceresi2: false,
      AnketFilter: {},
      AnketFilterText: "",
    };
  },
  methods: {
    rightDrawer2() {
      this.FilitrelemePenceresi2 = !this.FilitrelemePenceresi2;
    },
    Get() {},
    FilterDuzenleme() {
      this.AnketFilterText = "";
      for (var filter in this.AnketFilter) {
        if (this.AnketFilter[filter]) {
          this.AnketFilterText +=
            " and cevap->'" +
            filter +
            "' ->> 'Cevap' ='" +
            this.AnketFilter[filter] +
            "'";
        }
      }
      this.rightDrawer2();
    },
    ExcelExport(table, name) {
      let uri = "data:application/vnd.ms-excel;base64,";
      let template =
        '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--> <meta charset="utf-8"></head><body><table>{table}</table></body></html>';
      let base64 = function (s) {
        return window.btoa(unescape(encodeURIComponent(s)));
      };
      let format = function (s, c) {
        return s.replace(/{(\w+)}/g, function (m, p) {
          return c[p];
        });
      };
      if (!table.nodeType) table = this.$refs.ExcelExportTable;
      var ctx = { worksheet: name || "Worksheet", table: table.innerHTML };
      var a = document.createElement("a");
      a.href = uri + base64(format(template, ctx));
      a.download = name + ".xls";
      a.click();
    },
  },
  created() {
    this.ActionsSingleGet({
      Service: "AnktAnket",
      Id: this.AnktAnketId,
    }).then((res) => {
      this.FormData = res.Data;
      this.FormJson = JSON.parse(this.FormData.Anketjson);
      for (var Bolumler in this.FormJson) {
        for (var Form in this.FormJson[Bolumler].FormFiled) {
          if (
            this.FormJson[Bolumler].FormFiled[Form].type == "combobox" ||
            this.FormJson[Bolumler].FormFiled[Form].type == "radiobutton"
          ) {
            this.$set(
              this.AnketFilter,
              this.FormJson[Bolumler].FormFiled[Form].Id,
              ""
            );
          }
        }
      }
    });
  },
};
</script>

<style>
.dropdown-menu.show {
  overflow-y: scroll !important;
  height: 200px !important;
}
</style>

<template>
  <div v-if="FormJson">
    <div role="tablist">
      <div class="col-sm-12">
        <div class="text-sm-end">
          <button
            type="button"
            class="btn btn-secondary btn-rounded mb-2 me-2"
            @click="rightDrawer2()"
          >
            <i class="mdi mdi-text-search me-1"></i>
            {{ $t("AnktAnket.Page.Filtreleme") }}
          </button>
          <button
            type="button"
            class="btn btn-success btn-rounded mb-2 me-2"
            @click="ExcelExport(FormData.Baslik, FormData.Baslik)"
          >
            <i class="mdi mdi-file-export-outline me-1"></i>
            {{ $t("AnktDetay.Page.ExceleAktar") }}
          </button>
        </div>
      </div>

      <div class="table-responsive" ref="ExcelExportTable">
        <table
          class="table table-hover mb-0"
          ref="table"
          v-for="(Bolumler, Bolumindex) in FormJson"
          :key="Bolumindex"
        >
          <thead>
            <tr>
              <th colspan="4">
                <i :class="Bolumler.FormIcon"></i> {{ Bolumler.FormTitle }}
              </th>
            </tr>
          </thead>
          <template v-for="(Form, index) in Bolumler.FormFiled">
            <AnketYanitlarSingleOran
              :Form="Form"
              :AnktAnketId="AnktAnketId"
              :key="Bolumindex + '-' + index + '-' + AnketFilterText"
              :AnketFilterText="AnketFilterText"
            />
          </template>
        </table>
      </div>

      <Drawer
        @close="rightDrawer2"
        :align="'right'"
        :closeable="true"
        :maskClosable="true"
        :zIndex="1002"
      >
        <div v-if="FilitrelemePenceresi2">
          <div class="offcanvas-header">
            <h5 class="offcanvas-title" id="offcanvasExampleLabel">
              {{ $t("AnktAnket.Filtreleme.Title") }}
            </h5>
          </div>
          <div class="offcanvas-body">
            {{ $t("AnktAnket.Filtreleme.Content") }}

            <div v-for="(Bolumler, Bolumindex) in FormJson" :key="Bolumindex">
              <template v-for="(Form, index) in Bolumler.FormFiled">
                <b-form-group
                  :key="index"
                  :label="Form.props.title"
                  label-for="text"
                  class="mt-3"
                  v-if="Form.type == 'combobox' || Form.type == 'radiobutton'"
                >
                  <select
                    class="form-select"
                    type="text"
                    v-model="AnketFilter[Form.Id]"
                  >
                    <option value="">Seçiniz</option>
                    <option
                      v-for="options in Form.options"
                      :key="options.Id"
                      :value="options.Id"
                    >
                      {{ options.value }}
                    </option>
                  </select>
                </b-form-group>
              </template>
            </div>

            <b-button
              @click="FilterDuzenleme()"
              class="btn btn-primary mt-3"
              variant="primary"
            >
              {{ $t("AnktAnket.Filtreleme.Button") }}</b-button
            >
          </div>
        </div>
      </Drawer>
    </div>
  </div>
</template>
